module.exports = __webpack_public_path__ + "static/media/nb_headerlogo.abf1b2a1.png";